<ng-container *transloco="let t">
  <!-- begin :: Dialog content -->
  <mat-dialog-content class="p-0 w-100">
    <!-- begin :: Header -->
    <div class="py-5 px-4 px-md-10 border-bottom">
      <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-4">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-70px me-4">
            <div class="symbol-label bg-white border border-gray-200">
              <img src="assets/media/prime-scan/prime-scan-logo.png" class="h-60px w-auto" alt="Prime Scan" />
            </div>
          </div>

          <div>
            <h2 class="text-gray-900 fw-bold fs-3 mb-1">Prime Scan</h2>
            <div class="text-gray-700 fw-semibold fs-7" transloco="sentence_login_setup_zebra"></div>
          </div>
        </div>

        <div class="d-flex align-items-center w-100 w-md-auto" *ngxPermissionsOnly="'canAccessJwtToken'">
          <button class="btn btn-light-primary btn-sm d-inline-flex align-items-center justify-content-center px-5 w-100 w-md-auto" CopyToClipboard [copyInput]="token()">
            <span class="ms-2" transloco="label_copy_authentication_token"></span>
          </button>
        </div>
      </div>
    </div>
    <!-- end :: Header -->

    <!-- begin :: Tabs group -->
    <mat-tab-group class="mx-3 mx-md-5 mb-5">
      <!-- begin :: Tab 1 -->
      <mat-tab [label]="t('label_login_via_qr')">
        <div class="container-fluid px-4 px-md-8 py-7 w-md-800px d-flex flex-column justify-content-center">
          <div class="text-center">
            @if (loading()) {
              <div class="py-10">
                <div class="spinner-border text-primary mb-4" role="status"></div>
                <div class="text-gray-600 fs-7" transloco="label_loading"></div>
              </div>
            } @else if (error()) {
              <div class="text-danger fw-semibold fs-6 p-5">{{ error() }}</div>
            } @else if (imageUrl()) {
              <div class="mb-7">
                <h4 class="fw-bold text-gray-900 fs-3 mb-2" transloco="label_login_with_qr_code"></h4>
                <div class="text-gray-600 fs-6" transloco="sentence_scan_qr_code_zebra"></div>
              </div>

              <div class="row justify-content-evenly align-items-center mb-8">
                <div class="col-12 col-md-auto text-center">
                  <div class="p-4 border border-gray-300 rounded bg-white d-inline-block">
                    <img [src]="imageUrl()!" alt="QR Code" class="rounded h-300px" />
                  </div>
                </div>

                <div class="col-12 col-md-auto text-center">
                  <div class="text-center">
                    <a href="https://www.zebra.com/ap/en/products/mobile-computers/handheld/tc2x-series/tc22.html" target="_blank" class="d-inline-block">
                      <img src="./assets/media/general/zebra-tc22.webp" alt="Zebra Scanner" class="h-250px" />
                    </a>
                    <div class="mt-3 text-gray-600 fs-8 fw-semibold">Zebra TC22</div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </mat-tab>
      <!-- end :: Tab 1 -->

      <!-- begin :: Tab 2 -->
      <mat-tab [label]="t('label_setup_application')">
        <div class="container-fluid px-4 px-md-4 py-7 min-h-400px">
          <div class="mb-6">
            <h4 class="fw-bold text-gray-900 fs-3 mb-2" transloco="label_install_prime_scan"></h4>

            <div class="text-gray-600 fs-6 mb-4">
              <span transloco="sentence_choose_one_method"></span>
              <a
                [href]="setupMode() === 1 ? 'assets/media/prime-scan/prime-scan-update.pdf' : 'assets/media/prime-scan/prime-scan-install.pdf'"
                [download]="setupMode() === 1 ? 'Prime_Scan_Update_Guide.pdf' : 'Prime_Scan_install_Guide.pdf'"
                class="text-primary link-underline ms-5"
              >
                <i class="bi bi-file-earmark-pdf fs-4 me-1 text-primary"></i>
                <span transloco="label_download_guide"></span>
              </a>
            </div>
          </div>

          <div class="row g-8 align-items-start">
            <div class="col-12 col-md-6">
              <div class="mb-3">
                <span class="badge badge-primary fw-bold px-4 py-2" transloco="dynamic_option_value" [translocoParams]="{ value: 1 }"></span>
              </div>

              <h6 class="fw-bolder text-gray-800 mb-3 fs-6" transloco="label_install_via_stagenow"></h6>
              <mat-radio-group class="d-flex gap-4 mb-5" [value]="setupMode()" (change)="setupMode.set($event.value)" color="primary">
                <mat-radio-button [value]="1" class="fw-bold text-gray-700 fs-7"><span transloco="label_update"></span></mat-radio-button>
                <mat-radio-button [value]="2" class="fw-bold text-gray-700 fs-7"><span transloco="label_install"></span></mat-radio-button>
              </mat-radio-group>
              <div class="text-gray-700 fs-7" [innerHTML]="t('paragraph_zebra_stagnow_instructions')"></div>
            </div>

            <div class="col-12 col-md-6 text-center">
              <div class="d-inline-block p-3 border border-gray-300 rounded bg-white">
                @if (setupMode() === 1) {
                  <img src="./assets/media/prime-scan/stage-now-update-qr.png" alt="StageNow Update Barcode" class="rounded img-fluid w-100" />
                } @else {
                  <img src="./assets/media/prime-scan/stage-now-install-qr.png" alt="StageNow Install Barcode" class="rounded img-fluid w-100" />
                }
              </div>
            </div>
          </div>

          <div class="separator separator-content my-10 border-secondary border-5 separator-dotted"><span class="badge rounded-pill badge-light-dark" transloco="label_or"></span></div>

          <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-5">
            <div>
              <div class="mb-3">
                <span class="badge badge-primary fw-bold px-4 py-2" transloco="dynamic_option_value" [translocoParams]="{ value: 2 }"></span>
              </div>

              <h6 class="fw-bolder text-gray-800 mb-2 fs-5" transloco="label_install_via_play_store"></h6>
              <p class="text-gray-700 fs-6 mb-0" transloco="sentence_download_app_playstore"></p>
            </div>

            <div class="text-md-end">
              <a href="https://play.google.com/store/apps/details?id=com.primescan.app" target="_blank">
                <img src="assets/media/prime-scan/google-play-store-logo.png" class="h-100px" alt="Google Play" />
              </a>
            </div>
          </div>
        </div>
      </mat-tab>
      <!-- end :: Tab 2 -->
    </mat-tab-group>
  </mat-dialog-content>

  <!-- begin :: Dialog actions -->
  <mat-dialog-actions align="end" class="px-4 px-md-8 py-3 border-top">
    <button mat-button mat-dialog-close class="btn btn-sm btn-light"><span transloco="label_close"></span></button>
  </mat-dialog-actions>
  <!-- end :: Dialog actions -->
</ng-container>
